import { render, staticRenderFns } from "./GramContactTel.vue?vue&type=template&id=2f27b1a6"
import script from "./GramContactTel.vue?vue&type=script&lang=ts"
export * from "./GramContactTel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports